<template>
    <div>
        <div v-if="attrs.type == 'putonprice'">
            <Table stripe :columns="defaultData.columns" :data="defaultData.data"></Table>
        </div>
        <div v-else>
            <Table stripe :columns="columns" :data="value"  v-if="columns.length > 0 && value.length > 0">                         
                <template #action="{ row }">
                    <div v-if="attrs.isAction">  
                        <Button :to="attrs.infoUrl+row.id">详情</Button>
                    </div>
                </template>                
            </Table>
            <div v-else>暂无数据</div>
        </div>        
    </div>
</template>
<script>
    /**
     * 用于纯展示的table
     * 增加弹窗table纯显示 默认数据putonprice，以后增加其余数据直接在./data  modif by wxf in 2021 4.2
     */
    import { defaultSetData } from "./data";
    export default {
        name: 'LyShowTable',
        props: {
            value: {
                type: [Array, String],
                default: () => []
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return {
                defaultData: {}
            }
        },
        created() {
            if(this.attrs.type !== 0) {
                // 根据选择的type设置默认数据
                for(let k in defaultSetData) {
                    if(k == this.attrs.type) {
                        this.defaultData = defaultSetData[k]
                    }
                }
            }
        },
        computed : {
            columns () {
                let col = []
                if (this.attrs.items) {
                    this.attrs.items.forEach(el => {
                        if (el.title.length > 0) {
                            col.push(el)
                        }
                    })
                }
                console.log('attrs', this.attrs)
                if(this.attrs.isAction) {
                    col.push({
                        title: '操作',
                        slot: 'action',
                        fixed: 'right'
                    })
                }                
                return col
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/show-table/src/index.vue